import SkeletonRectangle from '../../../../skeleton/skeleton.rectangle.component';
import { makeDefaultStylingContext } from '../../../../utils/style';
import { CONTENT_GAP, getItemsTop, getMetadataBottom } from '../../../hero.style';
import { getPaddings, getSizes, getTitleFont } from '../../../heroMetadata/customer/default/heroMetadata.style';
import { sizes as heroNavSizes } from '../../../heroNav/heroNav.style';

export const defaultContext = makeDefaultStylingContext();

export const getInitialStyle = ({ screenSize } = defaultContext) => {
  const sizes = getSizes(screenSize);
  const paddings = getPaddings(screenSize);
  const metadataBottom = getMetadataBottom(screenSize);
  const itemsTop = getItemsTop(screenSize);
  const itemSize = heroNavSizes[screenSize];
  const gap = CONTENT_GAP[screenSize];

  return {
    Metadata: {
      mountY: 1,
      h: metadataBottom,
      y: metadataBottom,
      flex: {
        direction: 'column',
        justifyContent: 'flex-end',
      },
      ProgramLogo: {
        type: SkeletonRectangle,
        w: sizes.programLogo.w,
        h: sizes.programLogo.h,
      },
      IconsRow: {
        type: SkeletonRectangle,
        w: 500,
        h: sizes.iconsRow.h,
        flexItem: { marginTop: paddings.iconsRow.paddingTop },
      },
      Title: {
        flexItem: { marginTop: paddings.title.paddingTop },
        h: getTitleFont().lineHeight * 2,
        flex: {
          direction: 'column',
        },
        FirstLine: {
          type: SkeletonRectangle,
          w: 700,
          h: getTitleFont().lineHeight,
        },
        SecondLine: {
          type: SkeletonRectangle,
          w: 500,
          h: getTitleFont().lineHeight,
        },
      },
    },
    Items: {
      y: itemsTop,
      children: [...Array(6)].map((_, index) => ({
        type: SkeletonRectangle,
        x: index * (itemSize.w + gap),
        ...itemSize,
      })),
    },
  };
};
